export default __webpack_public_path__ + "static/media/qr-code-vmp.a34adeb2.png";